import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { isAuthenticated } from "./Auth";
import { socket } from "./Socket";

const readCachedFlag = () =>
  parseInt(localStorage.getItem("check_card_status") || 0) === 1;

const getCurrentUserId = () => {
  const token = isAuthenticated();
  if (!token) return null;
  try {
    return jwtDecode(token)?.id || null;
  } catch {
    return null;
  }
};

export const useSkipCardCheck = () => {
  const [skipCardCheck, setSkipCardCheck] = useState(readCachedFlag);

  useEffect(() => {
    const handler = (data) => {
      const userId = getCurrentUserId();
      if (!userId || parseInt(userId) !== parseInt(data.user_id)) return;
      const flag = parseInt(data.override_cc_checker_flag) === 1;
      localStorage.setItem("check_card_status", flag ? 1 : 0);
      setSkipCardCheck(flag);
    };

    const onStorage = (e) => {
      if (e.key === "check_card_status") setSkipCardCheck(readCachedFlag());
    };

    socket.on("bddw_overrideCCCheckerStatusChange", handler);
    window.addEventListener("storage", onStorage);
    return () => {
      socket.off("bddw_overrideCCCheckerStatusChange", handler);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return skipCardCheck;
};
